module.exports = __webpack_public_path__ + "img/Fortebon_1.f418cbc5.jpg";